export default __webpack_public_path__ + "static/1-fitness-0d318388b0563631e5ff64b7ac2c6743.png";